export default {
  AGUARDANDO: 'AGUARDANDO',
  EM_ANDAMENTO: 'EM_ANDAMENTO',
  FINALIZADA: 'FINALIZADA'
}



// WEBPACK FOOTER //
// ./src/libs/constants/vistoria/status.js